import { render, staticRenderFns } from "./ShowShopPrifileItem.vue?vue&type=template&id=153b877c&scoped=true&"
import script from "./ShowShopPrifileItem.vue?vue&type=script&lang=ts&"
export * from "./ShowShopPrifileItem.vue?vue&type=script&lang=ts&"
import style0 from "./ShowShopPrifileItem.vue?vue&type=style&index=0&id=153b877c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153b877c",
  null
  
)

export default component.exports